import styled from 'styled-components';

import CloseSvg from '../../assets/icons/close.svg?react';
import { ThemeType } from '../../themeStyled';

const IconWrapper = styled.div`
	border: 1px solid ${({ theme }: { theme: ThemeType }) => theme.colors.erik.veryLightGray};
	border-radius: 12px;
	padding: 12px;
	width: 48px; /* 24px ikona + 12px padding z každej strany */
	height: 48px;

	background-color: white;
	box-shadow: ${({ theme }: { theme: ThemeType }) => theme.boxShadow.default};

	display: flex;
	align-items: center;
	justify-content: center; /* vycentruj ikonu */

	flex-shrink: 0; /* bráni roztiahnutiu, ak je vo flex kontejnery */

	&:hover {
		cursor: pointer;
		box-shadow: ${({ theme }: { theme: ThemeType }) => theme.boxShadow.hover};
	}

	svg {
		width: 24px;
		height: 24px;
		flex-shrink: 0; /* chráni SVG pred deformáciou */
	}
`;

interface IconProps {
	onClick?: () => void;
}

const CloseIcon = ({ onClick }: IconProps) => {
	return (
		<IconWrapper onClick={onClick}>
			<CloseSvg />
		</IconWrapper>
	);
};

export default CloseIcon;
